export default __webpack_public_path__ + "static/12.03-e5bf558a09b014ff277d93c8c0505a44.png";